import React from "react";
import {ProductForm, UnverfiedProductForm} from "../components";

export const ProductPage: React.FC = (_props) => <ProductForm />;

export const UnverifiedProductpage : React.FC = (_props) => <UnverfiedProductForm />
